import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import {
  AppUpdateService,
  logAppUpdate,
} from '@/services/app-update/app-update.service';

/** Cancels the SPA navigation when a downloaded version is ready to take over. */
export const appUpdateGuard: CanActivateChildFn = (_route, state) => {
  const updates = inject(AppUpdateService);
  if (!updates.updateReady) {
    if (updates.state() !== 'idle') {
      logAppUpdate('navigation continues', {
        url: state.url,
        state: updates.state(),
      });
    }
    return true;
  }
  logAppUpdate('navigation handoff', { url: state.url });
  updates.navigateWithUpdate(state.url);
  return false;
};
